module.exports = __webpack_public_path__ + "static/media/apple_music_dark.e292721a.svg";